export default __webpack_public_path__ + "static/media/pep.2c088aa3.jpg";